document.addEventListener("DOMContentLoaded", () => {
  const openPopup = document.getElementById('openMuralPopup');
  const muralPopup = document.querySelector('.section-mural-application');
  const closePopup = muralPopup.querySelector('.pswp__button--close');

  if (openPopup) {
    openPopup.addEventListener('click', () => {
      muralPopup.setAttribute('data-popup', 'true');
    });
  }

  if (closePopup) {
    closePopup.addEventListener('click', () => {
      muralPopup.setAttribute('data-popup', 'false');
    });
  }
});